<template>
  <v-app
    ><v-main class="include-hero">
      <v-container>
        <v-card style="border-radius: 15px">
          <v-icon
            icon="mdi-emoticon-confused"
            size="x-large"
            style="margin: 10px 30px 15px 10px"
          ></v-icon>
          <h1 style="display: inline-block">404!Seite nicht gefunden</h1>
        </v-card>
      </v-container>
    </v-main></v-app
  >
</template>
